import type { ProductV2 } from '@common'

export const resolveProductBackgroundVariant = (product: ProductV2) => {
  if (product.id === 'com.supercell.laser.scid.seasonpass.basic') return 'passbasic'
  if (product.id === 'com.supercell.laser.scid.seasonpass.plus') return 'passpremium'
  return undefined
}
